import React, { memo } from 'react';
import { T_KEYS_NO_BECAUSE_YOU_PLAYED_GAMES } from '../../../../../../../main/Games/constants';
import { ITranslateMethod, TTranslationDefaultValue } from 'js/hooks/i18n/types';

type CategoryNameProps = {
    t: ITranslateMethod;
    categoryName?: string;
    isRecommended?: boolean;
    mostPlayedGame?: string;
    username?: string;
    isBecauseYouPlayed?: boolean;
    isCategoryName?: boolean;
    className?: string;
}

const CategoryName = ({
    t,
    categoryName = '',
    isRecommended,
    mostPlayedGame,
    username,
    isBecauseYouPlayed = false,
    isCategoryName = false,
    className = ''
}: CategoryNameProps) => {
    const becauseYoulayedMostPlayed = isBecauseYouPlayed && mostPlayedGame ? `${t(categoryName, mostPlayedGame && [mostPlayedGame] as unknown as TTranslationDefaultValue)}` : '';
    const becuseYouPlayedNoMostPlayed = isBecauseYouPlayed && !mostPlayedGame ? `${t(T_KEYS_NO_BECAUSE_YOU_PLAYED_GAMES)}` : '';
    const commonCategory = categoryName ? `${t(categoryName)}${isRecommended ? `, ${username}` : ''}` : '';

    return isCategoryName ? (
        <h2 className={className}>
            {becauseYoulayedMostPlayed || becuseYouPlayedNoMostPlayed || commonCategory}
        </h2>
    ) : null;
};

export default memo(CategoryName);
